
import React from "react";
import ResultLayout from "./ResultLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { ResultIcon, KeyValueRow } from "./components";

export default function PaymentFail() {
  const nav = useNavigate();
  const { search } = useLocation();
  const q = new URLSearchParams(search);

  const orderId   = q.get("orderId");
  const resultCode= q.get("resultCode");
  const resultMsg = q.get("resultMsg");
  const payMethod = q.get("payMethod");
  const amt       = q.get("amt");
  const goodsName = q.get("goodsName");

  return (
    <ResultLayout title="결제 실패">
      <div className="contents-wrap">
        <div className="text-cent" style={{padding:'24px 0 8px'}}>
          <ResultIcon type="fail" />
          <h3 style={{marginBottom:4}}>결제가 완료되지 않았습니다.</h3>
          <p className="sub-txt">{resultMsg || "승인이 거절되었거나 사용자가 결제를 취소했습니다."}</p>
        </div>

        <div className="lineTop_tb01 mt18">
          <table className="lineTop_tb2">
            <tbody>
              <KeyValueRow label="주문번호" value={orderId} />
              <KeyValueRow label="상품명" value={goodsName} />
              <KeyValueRow label="결제수단" value={payMethod} />
              <KeyValueRow label="결제요청금액" value={amt && Number(amt).toLocaleString() + "원"} />
              <KeyValueRow label="결과코드" value={resultCode} />
              <KeyValueRow label="결과메시지" value={resultMsg} />
            </tbody>
          </table>
        </div>

        <div className="btn-wrap text-cent mt30">
          <button className="btn btn-blue" onClick={() => nav(-1)}>다시 결제하기</button>
          <button className="btn btn-gray ml10" onClick={() => nav("/")}>홈으로</button>
        </div>
      </div>
    </ResultLayout>
  );
}
